
[
  {
    "id": "GET-VER-L1-002",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Bereken: $\\frac{2}{5}$ + $\\frac{1}{5}$ + $\\frac{1}{5}$ =",
    "options": [
      "$\\frac{4}{15}$",
      "$\\frac{4}{5}$",
      "$\\frac{1}{5}$",
      "1 hele"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_optellen",
    "familyId": "GET-BREUK-OPTELLEN",
    "explanation": "De onderkant (noemer) blijft hetzelfde. Tel alleen de bovenkant (teller) op: 2 + 1 + 1 = 4. Dus $\\frac{4}{5}$.",
    "distractorExplanations": {
      "0": "Je hebt de onderkant ook opgeteld (5 + 5 + 5). Dat mag niet! De onderkant blijft 5.",
      "2": "Je bent er twee vergeten. Tel alle bovenkantjes op: 2 + 1 + 1 = 4.",
      "3": "$\\frac{4}{5}$ is nog geen hele. Een hele is $\\frac{5}{5}$!"
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 4,
        "denominator": 5,
        "label": "4 van de 5 stukken",
        "visualType": "chocolate",
        "usePizza": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VER-L2-001",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "In een zak zitten 20 knikkers. $\\frac{1}{4}$ deel is rood. Hoeveel rode knikkers zijn dat?",
    "options": [
      "5 knikkers",
      "4 knikkers",
      "10 knikkers",
      "15 knikkers"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "$\\frac{1}{4}$ betekent: deel door 4. Dus: 20 : 4 = 5 rode knikkers.",
    "distractorExplanations": {
      "1": "Je hebt naar het getal 4 gekeken. Maar $\\frac{1}{4}$ betekent: deel door 4!",
      "2": "Dit is de helft ($\\frac{1}{2}$). Maar een kwart is minder dan de helft!",
      "3": "Dit zijn de knikkers die NIET rood zijn ($\\frac{3}{4}$ van 20)."
    },
    "visualAid": {
      "type": "fraction",
      "data": {
        "numerator": 1,
        "denominator": 4,
        "label": "1 van de 4 delen = 5 knikkers",
        "visualType": "pizza",
        "usePizza": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-VER-L2-002",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Als je deze breuken optelt, wat krijg je dan? $\\frac{1}{2}$ + $\\frac{1}{2}$ + $\\frac{1}{2}$ + $\\frac{1}{2}$ = ...",
    "options": [
      "2",
      "1$\\frac{3}{4}$",
      "3",
      "2$\\frac{1}{2}$"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_optellen",
    "familyId": "GET-BREUK-OPTELLEN",
    "explanation": "Er komt steeds een half ($\\frac{1}{2}$) bij. Kijk: anderhalf + een half = 2.",
    "distractorExplanations": {
      "1": "Je deed er een kwart ($\\frac{1}{4}$) bij. Maar de stapjes zijn een half ($\\frac{1}{2}$)!",
      "2": "Je sloeg een getal over. Tel rustig: $\\frac{1}{2}$, 1, 1$\\frac{1}{2}$, 2...",
      "3": "Je deed er een hele bij. Maar de stapjes zijn een half!"
    },
    "visualAid": {
      "type": "numberline",
      "data": {
        "start": 0,
        "end": 3,
        "highlight": [
          0.5,
          1,
          1.5,
          2
        ],
        "label": "Getallenlijn: +0,5 per stap"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L2-001",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken uit: 52 - 27 =",
    "options": [
      "25",
      "35",
      "29",
      "15"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-LENEN",
    "explanation": "Je kunt 7 niet van 2 afhalen. Dus leen je 1 van de 5 (wordt 4). Nu wordt 2 → 12. Dan: 12 - 7 = 5 (eenheden), 4 - 2 = 2 (tientallen). Dus 25.",
    "distractorExplanations": {
      "1": "Je bent vergeten te lenen! 2 is kleiner dan 7, dus je moet lenen.",
      "2": "Rekenfoutje. Check je lenen: 12 - 7 = 5.",
      "3": "Je hebt verkeerd geleend. Probeer het stapje voor stapje."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Lenen bij Aftrekken",
        "content": "Als het bovenste cijfer kleiner is, leen je 1 van de volgende kolom. Die 1 is 10 waard!",
        "icon": "alert"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L2-002",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken uit: 83 - 48 =",
    "options": [
      "35",
      "45",
      "25",
      "31"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-LENEN",
    "explanation": "Lenen! 3 is kleiner dan 8. Leen 1 van de 8 (wordt 7). Nu: 13 - 8 = 5 (eenheden), 7 - 4 = 3 (tientallen). Dus 35.",
    "distractorExplanations": {
      "1": "Rekenfoutje bij het lenen. Check: 13 - 8 = 5.",
      "2": "Je bent vergeten te lenen bij de tientallen.",
      "3": "Rekenfoutje bij de eenheden. Na het lenen wordt het 13 - 8 = 5, niet 1. Tel het na op je vingers of met een getallenlijn."
    }
  },
  {
    "id": "GET-AFT-L2-003",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken uit: 124 - 67 =",
    "options": [
      "57",
      "67",
      "47",
      "63"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-LENEN",
    "explanation": "Lenen! 4 < 7, dus leen. 14 - 7 = 7 (eenheden). Dan 1 < 6, dus weer lenen. 11 - 6 = 5 (tientallen). Dus 57.",
    "distractorExplanations": {
      "1": "Je hebt te veel afgetrokken. Check je lenen goed.",
      "2": "Rekenfout. Je moet twee keer lenen!",
      "3": "Je leende bij de eenheden (14 - 7 = 7), maar vergat dat de tientallen daardoor 1 minder werden. Het wordt 1 - 6, en daar moet je weer lenen: 11 - 6 = 5."
    }
  },
  {
    "id": "GET-VGL-L2-001",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Zet van klein naar groot: $\\frac{1}{3}$, $\\frac{1}{2}$, $\\frac{1}{4}$",
    "options": [
      "$\\frac{1}{4}$, $\\frac{1}{3}$, $\\frac{1}{2}$",
      "$\\frac{1}{2}$, $\\frac{1}{3}$, $\\frac{1}{4}$",
      "$\\frac{1}{3}$, $\\frac{1}{4}$, $\\frac{1}{2}$",
      "Ze zijn allemaal even groot"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "Van klein naar groot: $\\frac{1}{4}$ (kleinste stukken), $\\frac{1}{3}$ (middelste), $\\frac{1}{2}$ (grootste). Hoe groter de onderkant, hoe kleiner de stukken!",
    "distractorExplanations": {
      "1": "Dit is van groot naar klein! De vraag is van klein naar groot.",
      "2": "Niet helemaal. $\\frac{1}{4}$ is het kleinst, niet $\\frac{1}{3}$.",
      "3": "Ze zijn niet allemaal even groot!"
    }
  },
  {
    "id": "GET-VGL-L2-002",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Welke breuk is groter: $\\frac{3}{4}$ of $\\frac{5}{8}$?",
    "options": [
      "$\\frac{3}{4}$",
      "$\\frac{5}{8}$",
      "Ze zijn even groot",
      "Kan je niet zeggen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_vergelijken",
    "familyId": "GET-BREUK-VGL",
    "explanation": "$\\frac{3}{4}$ is groter. Maak ze gelijk: $\\frac{3}{4}$ = $\\frac{6}{8}$. En $\\frac{6}{8}$ is groter dan $\\frac{5}{8}$.",
    "distractorExplanations": {
      "1": "$\\frac{5}{8}$ is kleiner! $\\frac{3}{4}$ = $\\frac{6}{8}$, en dat is meer.",
      "2": "Ze zijn niet even groot. $\\frac{3}{4}$ is iets groter.",
      "3": "Je kunt het wel vergelijken! Maak de onderkant gelijk."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Gelijknamig Maken",
        "content": "Maak de onderkant gelijk om te vergelijken. 3/4 = 6/8, dus 6/8 > 5/8.",
        "icon": "lightbulb"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-OPT-L2-001",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken kolomsgewijs uit: 47 + 38 =",
    "options": [
      "85",
      "75",
      "95",
      "65"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-OVERHOUDEN",
    "explanation": "Reken kolomsgewijs met overhouden.\nEenheden: 7 + 8 = 15. Schrijf 5 op, onthoud 1.\nTientallen: 4 + 3 = 7, plus 1 (onthouden) = 8.\nHet antwoord is 85.",
    "distractorExplanations": {
      "1": "Je bent vergeten de 1 die je onthield erbij te tellen! 4 + 3 = 7, plus 1 onthouden = 8.",
      "2": "Rekenfoutje bij het overhouden. Check: 7 + 8 = 15, schrijf 5 op en onthoud 1.",
      "3": "Te weinig. Check je berekening: 47 + 38 = 85."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 47,
        "operand2": 38,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-OPT-L2-002",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken kolomsgewijs uit: 156 + 287 =",
    "options": [
      "443",
      "433",
      "453",
      "343"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-OVERHOUDEN",
    "explanation": "Reken kolomsgewijs met overhouden.\nEenheden: 6 + 7 = 13. Schrijf 3 op, onthoud 1.\nTientallen: 5 + 8 = 13, plus 1 = 14. Schrijf 4 op, onthoud 1.\nHonderdtallen: 1 + 2 = 3, plus 1 = 4.\nHet antwoord is 443.",
    "distractorExplanations": {
      "1": "Je bent vergeten de 1 die je onthield bij de honderdtallen erbij te tellen! 1 + 2 = 3, plus 1 onthouden = 4.",
      "2": "Rekenfoutje bij het overhouden. Check elke kolom goed!",
      "3": "Te weinig. Check: 156 + 287 = 443."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 156,
        "operand2": 287,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-AFT-L2-004",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken kolomsgewijs uit: 324 - 158 =",
    "options": [
      "166",
      "176",
      "156",
      "266"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_aftrekken",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-LENEN",
    "explanation": "Kolomsgewijs aftrekken met lenen in meerdere kolommen.\nEenheden: 4 < 8, dus leen! 14 - 8 = 6.\nTientallen: 2 werd 1 (geleend), en 1 < 5, dus weer lenen! 11 - 5 = 6.\nHonderdtallen: 3 werd 2 (geleend). 2 - 1 = 1.\nHet antwoord is 166.",
    "distractorExplanations": {
      "1": "Rekenfoutje bij het lenen. Check: 14 - 8 = 6, en 11 - 5 = 6.",
      "2": "Rekenfoutje bij de tientallen. Na het lenen werd de 2 een 1 (je leende voor de eenheden). Dan 1 < 5, dus weer lenen: 11 - 5 = 6, niet 5.",
      "3": "Je vergat dat je bij de honderdtallen had geleend. De 3 werd 2 (door het lenen), dus 2 - 1 = 1, niet 2."
    },
    "visualAid": {
      "type": "rule",
      "data": {
        "title": "Lenen in Meerdere Kolommen",
        "content": "Als je moet lenen, vergeet niet dat de kolom waar je van leent 1 minder wordt! Check elke stap.",
        "icon": "alert"
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-OPT-L2-003",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken kolomsgewijs uit: 267 + 185 =",
    "options": [
      "452",
      "442",
      "462",
      "352"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-OVERHOUDEN",
    "explanation": "Reken kolomsgewijs met overhouden.\nEenheden: 7 + 5 = 12. Schrijf 2 op, onthoud 1.\nTientallen: 6 + 8 = 14, plus 1 (onthouden) = 15. Schrijf 5 op, onthoud 1.\nHonderdtallen: 2 + 1 = 3, plus 1 (onthouden) = 4.\nHet antwoord is 452.",
    "distractorExplanations": {
      "1": "Je bent vergeten de 1 die je onthield bij de honderdtallen erbij te tellen! 2 + 1 = 3, plus 1 onthouden = 4.",
      "2": "Rekenfoutje bij het overhouden. Check: 7 + 5 = 12, schrijf 2 op en onthoud 1.",
      "3": "Te weinig. Dit is een optelsom, geen aftreksom!"
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 267,
        "operand2": 185,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  },
  {
    "id": "GET-POS-L2-001",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Wat is de waarde van de 3 in het getal 203.506?",
    "options": [
      "300",
      "3.000",
      "30.000",
      "3"
    ],
    "correctAnswer": 1,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "positiewaarde",
    "familyId": "GET-POS-WAARDE",
    "explanation": "De 3 staat bij de duizendtallen. Dat is 3.000.",
    "distractorExplanations": {
      "0": "Dat is de waarde als de 3 bij de honderdtallen stond.",
      "2": "Dat is de waarde bij de tienduizendtallen, maar daar staat geen 3.",
      "3": "Dat is de waarde bij de eenheden."
    }
  },
  {
    "id": "GET-VER-L2-003",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "$\\frac{3}{5}$ van 40 is ...",
    "options": [
      "24",
      "20",
      "8",
      "30"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_deel_van",
    "familyId": "GET-BREUK-DEEL",
    "explanation": "Eén vijfde van 40 is 8. Drie vijfde is 3 × 8 = 24.",
    "distractorExplanations": {
      "1": "Je nam de helft. Maar het gaat om drie vijfde.",
      "2": "Dat is één vijfde, niet drie vijfde.",
      "3": "Je deed 40 - 10, maar je moet delen door 5 en dan vermenigvuldigen met 3."
    }
  },
  {
    "id": "GET-VGL-L2-003",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Welke is groter: 0,6 of 0,58?",
    "options": [
      "0,6",
      "0,58",
      "Ze zijn gelijk",
      "Niet te zeggen"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "decimalen",
    "familyId": "GET-DEC-VGL",
    "explanation": "0,6 is hetzelfde als 0,60. 0,60 is groter dan 0,58.",
    "distractorExplanations": {
      "1": "0,58 heeft meer cijfers, maar 0,60 is toch groter.",
      "2": "Ze zijn niet gelijk: 0,60 is groter dan 0,58.",
      "3": "Je kunt het wel zeggen door beide als honderdsten te schrijven."
    }
  },
  {
    "id": "GET-AFT-L2-005",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken uit: 91 - 47 =",
    "options": [
      "44",
      "54",
      "34",
      "46"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "aftrekken",
    "familyId": "GET-AFT-LENEN",
    "explanation": "Je leent van de 9, zodat 11 - 7 = 4 en 8 - 4 = 4. Dus 44.",
    "distractorExplanations": {
      "1": "Je vergat te lenen. 1 - 7 kan niet.",
      "2": "Rekenfoutje: 11 - 7 = 4, niet 3.",
      "3": "Je haalde de tientallen verkeerd af. 8 - 4 = 4."
    }
  },
  {
    "id": "GET-OPT-L2-004",
    "module": "Getalbegrip",
    "difficulty": 104,
    "question": "Reken kolomsgewijs uit: 128 + 76 =",
    "options": [
      "204",
      "214",
      "194",
      "216"
    ],
    "correctAnswer": 0,
    "questionType": "cijferend_optellen",
    "skill": "basisrekenen",
    "subSkill": "optellen",
    "familyId": "GET-OPT-OVERHOUDEN",
    "explanation": "Eenheden: 8 + 6 = 14, schrijf 4 en onthoud 1. Tientallen: 2 + 7 + 1 = 10, schrijf 0 en onthoud 1. Honderdtallen: 1 + 1 = 2. Dus 204.",
    "distractorExplanations": {
      "1": "Je hebt de onthouden 1 bij de tientallen vergeten.",
      "2": "Je telde de eenheden verkeerd; 8 + 6 = 14.",
      "3": "Je hield de onthouden 1 twee keer vast."
    },
    "visualAid": {
      "type": "column",
      "data": {
        "operation": "add",
        "operand1": 128,
        "operand2": 76,
        "showSteps": true
      },
      "showWhen": "wrong"
    }
  }
]
